import { Logotype } from "./Logotype";

export default Logotype;
